import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationPreview = ({ settings }) => {
  const activeNotifications = [
    settings?.inAppNotifications && { type: 'In-App', icon: 'Monitor', color: 'text-blue-500' },
    settings?.emailNotifications && { type: 'Email', icon: 'Mail', color: 'text-green-500' },
    settings?.smsNotifications && { type: 'SMS', icon: 'MessageSquare', color: 'text-orange-500' }
  ]?.filter(Boolean);

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Eye" size={20} className="text-primary" />
        <h2 className="font-heading text-xl font-semibold text-foreground">
          Notification Preview
        </h2>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        Here's how you'll receive notifications based on your current settings
      </p>

      {activeNotifications?.length > 0 ? (
        <div className="space-y-3">
          {activeNotifications?.map((notification) => (
            <div
              key={notification?.type}
              className="flex items-start gap-3 p-4 bg-muted/30 rounded-lg border border-border"
            >
              <div className={`mt-0.5 ${notification?.color}`}>
                <Icon name={notification?.icon} size={18} />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-medium text-foreground text-sm">
                    {notification?.type} Alert
                  </span>
                  <span className="text-xs text-success bg-success/10 px-2 py-0.5 rounded-full">
                    Active
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  {notification?.type === 'In-App' && 'Toast notifications will appear in the bottom-right corner while you\'re using the app'}
                  {notification?.type === 'Email' && 'Updates will be sent to your registered email address'}
                  {notification?.type === 'SMS' && 'Text messages will be sent to your phone number for urgent updates'}
                </p>
              </div>
            </div>
          ))}
          {settings?.quietHoursEnabled && (
            <div className="flex items-start gap-3 p-4 bg-muted/30 rounded-lg border border-border">
              <div className="mt-0.5 text-purple-500">
                <Icon name="Moon" size={18} />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-medium text-foreground text-sm">
                    Quiet Hours
                  </span>
                  <span className="text-xs text-warning bg-warning/10 px-2 py-0.5 rounded-full">
                    Enabled
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  Notifications will be silenced from {settings?.quietHoursStart} to {settings?.quietHoursEnd}
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-3">
            <Icon name="BellOff" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-sm font-medium text-foreground mb-1">
            All Notifications Disabled
          </p>
          <p className="text-sm text-muted-foreground">
            You won't receive any notifications. Enable at least one notification type above.
          </p>
        </div>
      )}
    </div>
  );
};

export default NotificationPreview;